export enum STORAGE {
  SELECTED_REGION = 'selectedRegion',
  SELECTED_CLASS = 'selectedClass',
}
